import { render, staticRenderFns } from "./User.Menu.Edit.vue?vue&type=template&id=1b079b06&scoped=true&"
import script from "./User.Menu.Edit.vue?vue&type=script&lang=js&"
export * from "./User.Menu.Edit.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.Edit.vue?vue&type=style&index=0&id=1b079b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b079b06",
  null
  
)

export default component.exports